import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule }   from '@angular/forms';

import { AppRoutingModule } from './app-routing/app-routing.module';

import { AppComponent } from './app.component';
import { ClientComponent } from './client/client.component';
import { ClientsComponent } from './clients/clients.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DocumentComponent } from './document/document.component';
import { DocumentsComponent } from './documents/documents.component';
import { SitemenuComponent } from './sitemenu/sitemenu.component';
import { TopmenuComponent } from './topmenu/topmenu.component';
import { MultiselectComponent } from './multiselect/multiselect.component';

// observable class extensions
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';

// observable operators
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/finally';
import 'rxjs/add/operator/toPromise'; // are we using this anywhere?
import { FormH1Component } from './form-h1/form-h1.component';
import { LoginComponent } from './login/login.component';
import { UserAuthService } from './user-auth.service';
import { CommentsComponent } from './comments/comments.component';

// custom pipes
import { CamelCasePipe } from './pipes';
import { OrgNrPipe } from './pipes';
import { PhonePipe } from './pipes';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';

@NgModule({
  declarations: [
    AppComponent,
    ClientComponent,
    ClientsComponent,
    DashboardComponent,
    DocumentComponent,
    DocumentsComponent,
    SitemenuComponent,
    TopmenuComponent,
    FormH1Component,
    LoginComponent,
    CommentsComponent,
    MultiselectComponent,
    CamelCasePipe,
    OrgNrPipe,
    PhonePipe,
    ForgotPasswordComponent
  ],
  imports: [
    BrowserModule,
    HttpModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
  ],
  providers: [UserAuthService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts